import { useContext, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { FiltersContext } from '../../../filters/context';
import { openExportOrdersModal } from '../../../store/export/orders/export-orders.actions';
import { messages } from './messages';
import { useDataExportFeatureGate } from '../../../feature-gates/use-data-export-feature-gate';

export const useExportOrders = () => {
  const dispatch = useDispatch();
  const { buildApiFilters } = useContext(FiltersContext);
  const apiFilters = buildApiFilters();
  const { isFeatureEnabled, disabledMessage } = useDataExportFeatureGate();

  const actionHandler = useCallback(() => {
    dispatch(openExportOrdersModal(apiFilters));
  }, [apiFilters, dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsExport,
      isDisabled: !isFeatureEnabled,
      disabledReason: disabledMessage,
    };
  }, [actionHandler, isFeatureEnabled, disabledMessage]);
};
